import { WidgetFormSubmissionWithWidget } from "@closerplatform/spinner-openapi";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { FormPayload } from "@fidget/common/models/chat/chatItems";
import { MessageTag } from "@fidget/common/models/messageTag";
import { Instance, types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

export const WidgetFormEventChatItem = types
  .compose(
    "WidgetFormEventChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.WidgetFormEvent),
      subtype: types.enumeration<MessageTag>("WidgetFormEventSubtype", Object.values(MessageTag)),
      eventData: types.frozen<FormPayload>(),
      submission: types.frozen<WidgetFormSubmissionWithWidget>(),
      message: types.maybe(types.string)
    })
  )
  .views((self) => ({
    get text() {
      const { name } = self.submission;
      if (self.subtype === MessageTag.MESSAGE_WITH_FORM) {
        return intl.formatMessage("messageWidgets.form.sent", { name });
      } else if (self.subtype === MessageTag.FORM_SUBMITTED) {
        const userAnswers = self.submission.userInputs
          ? [
            intl.formatMessage("messageWidgets.form.submitted", { name }),
            ...self.submission.userInputs.map((inputAnswer) => {
              const answer = inputAnswer.value || inputAnswer.values?.join(", ");

              return inputAnswer.inputName + ": <b>" + answer + "</b>";
            })
          ].join("\n")
          : intl.formatMessage("messageWidgets.form.noAnswer", { name });
        return userAnswers;
      }

      return "";
    }
  }));

export interface IWidgetFormEventChatItem extends Instance<typeof WidgetFormEventChatItem> { }
